<template>
  <transition name="modal" v-if="visible">
    <div class="wrapper_popup" id="order_confirmation">
      <div class="order_confirmation pb-4">
        <div class="header_bg"></div>
        <div class="img_order_confirmation">
          <img :src="$root.logo" class="w-48" />
        </div>
        <div class="text_order_confirmation text-center">
          <div v-html="text_accepted"></div>
        </div>
        <div v-if="order_data && order_data.ostatus_id==='in_queue'" class="flex flex-col items-center p-4 mb-4 text-sm text-[#7e2a0c] rounded-xl bg-[#fff7ed]" role="alert">
            <span v-if="order_data && order_data.num" class="text-2xl font-medium">Order &#8470;{{ order_data.num }}</span>
            <span class="text-center">
                {{ $root.getLangText({'fr': 'En raison du grand nombre de commandes, votre commande a été placée en attente. Vous recevrez une notification dès qu’elle sera acceptée. Veuillez vérifier régulièrement. Nous vous prions de nous excuser pour la gêne occasionnée.', 'en': 'Due to the high volume of orders, your order has been placed in a queue. You’ll receive a notification when it’s been accepted. Please keep checking. We apologise for any inconvenience this may cause'}) }}
            </span>
        </div>
        <div class="container px-4 mt-16">
          <div class="mb-4 relative" @click="sendToPay" v-if="payment_url && !is_fast_payment">
            <button class="border border-color-hotel border-2 px-4 h-[44px] rounded-lg w-full flex justify-center gap-2 text-lg items-center base-color">
              <svg xmlns="http://www.w3.org/2000/svg" class="animate-bounce w-6 h-6 fill-current base-color" viewBox="0 0 512 512">
                <title>Arrow Forward</title>
                <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100" />
              </svg>
              {{ $root.getKeyWord("order_online_pay") }} <span v-html="$root.showPrice(total_price)"></span>
            </button>
          </div>

          <button class="default_green_btn" v-if="displayViewOrdersButton" @click="openMyOrders" v-text="getTextViewOrderButton()"></button>

          <div class="text-center my-4" v-if="parent_section.is_hidden !== true">
            <a href="#" class="text-gray-600 underline text-center uppercase" @click="close" v-text="$root.getKeyWord('home')"></a>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { eventBus } from "../../main"

export default {
  name: "order_success_splash",

  data() {
    return {
      visible: false,
      client_name: "",
      section: null,
      parent_section: null,
      payment_url: null,
      total_price: 0,
      text_accepted: "",
      order_data: null,
    }
  },

  created() {
    eventBus.$on("order-success-splash", (data) => {
      this.section = data.section
      this.parent_section = data.parent_section
      this.client_name = data.client_name
      this.payment_url = data.payment_url
      this.total_price = data.total_price
      this.visible = true
      
      this.order_data = data.order_data

      this.setTextAcceptedOrder()
    })
  },

  computed: {
    displayViewOrdersButton() {
      if (this.section == null) return true

      return !this.section.hide_view_orders_button
    },
    is_fast_payment() {
      return !!(this.$root.hotel && this.$root.hotel.ext_data && this.$root.hotel.ext_data.is_fast_payment);
    }
  },

  methods: {
    close() {
      this.visible = false
      window.location.href = "/"
    },

    sendToPay() {
      window.open(this.payment_url, "_blank").focus()
      this.visible = false
      eventBus.$emit("toggle-my-orders")
    },

    openMyOrders() {
      this.visible = false
      eventBus.$emit("toggle-my-orders")
    },

    setTextAcceptedOrder() {
      let result = ""

      var text_accepted_section = this.getTextAcceptedOrder(this.section.text_accepted_order)
      var text_accepted_parent_section = this.getTextAcceptedOrder(this.parent_section.text_accepted_order)
      var text_accepted_hotel = this.getTextAcceptedOrder(this.$root.hotel.text_accepted_order)

      if (text_accepted_section) result = text_accepted_section
      else if (text_accepted_parent_section) result = text_accepted_parent_section
      else if (text_accepted_hotel) result = text_accepted_hotel
      else result = this.$root.getKeyWord("accept_order")

      this.text_accepted = result

      // set name
      if (result) {
        var name = localStorage.getItem("fs_name") != undefined ? localStorage.getItem("fs_name") : ""
        this.text_accepted = result.replace("#name#", name)
      }
    },

    getTextAcceptedOrder(text) {
      return text != "" && Object.keys(text).length > 0 && Object.values(text).filter((item) => item !== null && item !== "").length > 0
        ? // ? this.$root.stripTags(this.$root.getLangText(text))
          this.$root.getLangText(text)
        : ""
    },

    getTextViewOrderButton() {
      if (this.parent_section && this.parent_section.id === 224928 && this.$root.hotelCode === "swissotel-krasnyeholmy") {
        return this.$root.getLangText({ ru: "Посмотреть свое сообщение", en: "Check your message" })
      }

      return this.$root.getKeyWord("view_order")
    },
  },
}
</script>

<style>
.animate-ping {
  -webkit-animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite !important;
  animation: ping 2s cubic-bezier(0, 0, 0.2, 1) infinite !important;
}
</style>
